import { FC } from "react"
import { useTranslation } from "react-i18next"

interface INoValueProps {
    isInvalid?: boolean
    className?: string
}

const NoValue: FC<React.PropsWithChildren<INoValueProps>> = ({
    isInvalid,
    children,
    className,
}) => {
    const { t } = useTranslation()
    return (
        <span className={`${isInvalid ? 'color-red-500' : 'color-grey-500'} font-regular white-space-nowrap ${className}`}>
            {children || t('common.noValue')}
        </span>
    )
}

export default NoValue
